import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private darkMode = false;

  private readonly darkMode$$ = new BehaviorSubject<boolean>(false);

  /**
   * Emits whenever the colour scheme changes, and replays the current value to every
   * new subscriber.
   *
   * Added so embedded content can follow the platform's theme. An iframe is a separate
   * document with its own idea of light and dark, and it has no way to notice a class
   * appearing on our `<body>` — so the host has to say so. Replay matters here because
   * an embed usually mounts long after the theme was decided at login, and would
   * otherwise sit on the default until the user happened to toggle.
   *
   * Purely additive: `setDarkMode()` behaves exactly as before for its existing callers.
   */
  readonly darkMode$: Observable<boolean> = this.darkMode$$.asObservable();

  constructor() { }

  isDarkMode() {
    return this.darkMode;
  }

  setDarkMode(isDarkMode: boolean) {
    this.darkMode = isDarkMode;
    if (isDarkMode) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    this.darkMode$$.next(isDarkMode);
  }

  isInIframe(): boolean {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
}
